import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import cardStyle from "../../styles/CardCategory.module.css"
import GetSpace from "../../utils/space"
import { BasicCard } from "../BasicCard/BasicCard"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import Animate, { AnimationTypes } from "../Animate/Animate"

export interface CardItemProps {
  title: string
  subtitle: string
  icon: IconProp
  txtColor?: string
  iconColor?: string
  borderColor?: string
  bgColor?: string
}

export const CardItem: React.FC<CardItemProps> = ({
  title,
  subtitle,
  icon,
  iconColor,
  txtColor,
  borderColor,
  bgColor,
}) => {
  return (
    <Animate type={AnimationTypes.fadeIn} duration="1.5s">
      <div className={cardStyle.cardContent}>
        <div className={cardStyle.cardContent}>
          <FontAwesomeIcon icon={icon} style={{ marginLeft: "10px", fontSize: "14px", color: iconColor }} />

          <span className={cardStyle.cardMoneyTxt} style={{ width: "100%" }}>
            {title}
          </span>
        </div>

        <GetSpace left={5} />

        <BasicCard title={subtitle} borderColor={borderColor} bgColor={bgColor} txtColor={txtColor} />
      </div>
    </Animate>
  )
}
